import { jsxs as r, jsx as s } from "react/jsx-runtime";
import { ReactComponent as c } from "../../../../resources/graphics/cashback/cashback-icon.svg.js";
import { Pill as i } from "./style.js";
const l = ({
  percentage: o = 0,
  ...a
}) => /* @__PURE__ */ r(i, { ...a, "data-visible": !!o, children: [
  /* @__PURE__ */ s(c, {}),
  /* @__PURE__ */ r("span", { children: [
    /* @__PURE__ */ r("strong", { children: [
      o,
      "%"
    ] }),
    " cashback"
  ] })
] });
export {
  l as CashbackPercentagePill
};
